import { useTranslation } from 'react-i18next';
import { detectDevice } from '../../utils/deviceDetection';

const StickyDownloadCta = ({ deepLink, mode, webUrl }) => {
  const { t } = useTranslation();
  const device = detectDevice();

  const handlePrimary = () => {
    if (device === 'ios') {
      window.location.href = t('downloads.appStoreLink');
    } else if (device === 'android') {
      window.location.href = t('downloads.googlePlayLink');
    } else {
      const target = document.getElementById('gp-desktop-download');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  const handleSecondary = () => {
    window.location.href = deepLink;
  };

  const primaryLabel =
    mode === 'TEAMS' || mode === 'TOURNAMENT'
      ? t('open.preview.cta.joinWithTeam')
      : t('open.preview.cta.joinGame');

  return (
    <>
      <div className="gp-cta-spacer" />
      <div className="gp-cta">
        <div className="gp-cta__inner">
          <button className="gp-cta__primary" onClick={handlePrimary}>
            <span>{primaryLabel}</span>
            <span className="gp-cta__primary-sub">
              {t('open.preview.cta.joinGameSub')}
            </span>
          </button>
          <button className="gp-cta__secondary" onClick={handleSecondary}>
            {t('open.preview.cta.alreadyHaveApp')}
          </button>
          {webUrl && (
            <a className="gp-cta__secondary" href={webUrl}>
              {t('open.continueWeb')}
            </a>
          )}
        </div>
      </div>
    </>
  );
};

export default StickyDownloadCta;
